// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PxZR-","label":"styles_label__rLbVN"};